import { meta } from "./_meta";
import styles from './_hcp-moa.module.scss';
import HcpHero from "@/components-hcp/hero";
import HcpLongButton from "@/components-hcp/long-button";
import HcpPageFootnote from "@/components-hcp/page-footnote";
import { useMemo } from "react";
import HcpMoaActh from "./components/acth";
import HcpMoaCrf from "./components/crf";
import HcpPageReferences from "@/components-hcp/page-references";
import HcpDrQuote from "@/components-hcp/dr-quote";

export default function HcpMoa() {
  const references = useMemo(() => [
    <>Crenessity. Package insert. Neurocrine Biosciences, Inc.</>,
    <>Schr&ouml;der MAM, Claahsen-van der Grinten HL. Novel treatments for congenital adrenal hyperplasia. <em>Rev Endocr Metab Disord.</em> 2022;23(3):631-645. doi:10.1007/s11154-022-09717-w</>,
    <>Mallappa A, Merke DP. Management challenges and therapeutic advances in congenital adrenal hyperplasia. <em>Nat Rev Endocrinol.</em> 2022;18(6):337-352. doi:10.1038/s41574-022-00655-w</>,
    <>Gully D, Geslin M, Serva L, et al. 4-(2-Chloro-4-methoxy-5-methylphenyl)-<i>N</i>-[(1<i>S</i>)-2-cyclopropyl-1-(3-fluoro-4-methylphenyl)ethyl]5-methyl-<i>N</i>-(2-propynyl)-1,3-thiazol-2-amine hydrochloride (SSR125543A): a potent and selective corticotrophin-releasing factor<sub>1</sub> receptor antagonist. I. Biochemical and pharmacological characterization. <em>J Pharmacol Exp Ther.</em> 2002;301(1):322-332. doi:10.1124/jpet.301.1.322</>,
    <>Fleck BA, Hoare SR, Pick RR, Bradbury MJ, Grigoriadis DE. Binding kinetics redefine the antagonist pharmacology of the corticotropin-releasing factor type 1 receptor. <em>J Pharmacol Exp Ther.</em> 2012;341(2):518-531. doi:10.1124/jpet.111.188714</>
  ], []);
  return (
      <div className={styles.container}>
        <div className="container">
          <h1 className={`page-heading ${styles.hcpmoapgheading}`}>CRENESSITY blunts ACTH secretion at the source to help restore balance in the HPA axis<sup>1</sup></h1>
        </div>
        <HcpMoaActh />
        <HcpMoaCrf />
        <HcpDrQuote
          doctor={{
            name: 'Dr. Amrit Bhangoo',
            specialty: 'Pediatric Endocrinologist',
            image: '/images/components/CAH-HCP-Specialist-Dr-Bhangoo.png',
            note: 'Compensated by Neurocrine for sharing his views.'
          }}
          theme='tan'
          borderClassName="tablet:!p-[101px] tablet:!pb-[158px]"
          bottomTextColor="text-hcp-charcoal"
        >
          CRENESSITY is a game changer…It&rsquo;s a paradigm shift in the way we are looking at classic CAH treatment, because the mechanism of action is so different from just steroid replacement.”
        </HcpDrQuote>
        <section>
          <HcpLongButton
            iconType="Clinical-Information"
            label={<>Efficacy</>}
            description={<span className="inline-block max-w-[400px] leading-inherit">Review outcomes from CRENESSITY clinical trials.</span>}
            href="/clinical-information#trial-1-efficacy-link"
          />
          <HcpLongButton
            iconType="Contact-A-Rep"
            label={<>Get in Touch</>}
            description={<span className="inline-block max-w-[529px] leading-inherit">Sign up to schedule a call or visit with a Neurocrine representative.</span>}
            href="/support-resources#crm-sign-up"
          />
        </section>
        <HcpPageFootnote>
          ACTH=adrenocorticotropic hormone; CRF=corticotropin-releasing factor; CRF<sub>1</sub>=corticotropin-releasing 
          factor type 1; GC=glucocorticoid; HPA=hypothalamic-pituitary-adrenal.
        </HcpPageFootnote>
        <HcpPageReferences references={references} />
      </div>
  );
}

HcpMoa.getLayoutProps = (_pageProps, _router) => ({
  meta,
  hero: (
    <HcpHero
      imageSrc="/images/hero/MOA_Hero-Image.png"
      theme="peach"
      imageProps={{
        id: 'hero_kidney_inside',
        width: 630,
        height: 356,
      }}
    >
      RESHAPE <span className="text-hcp-tangerine">CAH</span> MANAGEMENT THROUGH&nbsp;CRF<sub>1</sub>
    </HcpHero>
  ),
});